
export const FETCH = 'FIELDS/FETCH'
export const CLEAR = 'FIELDS/CLEAR'



// WEBPACK FOOTER //
// ./src/store/modules/fields/mutations.js